/* eslint-env browser */
import { frontendURL } from '../../../helper/URLHelper';

const Kanban = () => import('./Index.vue');

export const routes = [
  {
    path: frontendURL('accounts/:accountId/kanban'),
    name: 'kanban_dashboard_index',
    meta: {
      permissions: ['administrator', 'agent', 'custom_role'],
    },
    component: Kanban,
  },
];
